import {DI_TOKENS} from '@/di/di.tokens';
import {ErrorCode} from '@/services/ErrorsService/ErrorsService.constants';

import axios from 'axios';
import {injected} from 'brandi';

import {AbstractStorage} from '@specials/localstorage';
import {AxiosHttpAdapter, HttpClient} from '@specials/project-user';

import {LocalStorageKeys} from '@/constants';
import {HttpCustomRetry} from '@/services/HttpCustomRetry/HttpCustomRetry';
import {Envs} from '@/types';

export class HttpClientProjectApi extends HttpClient {
  constructor(private readonly envs: Envs, private readonly localStorage: AbstractStorage) {
    super(
      new AxiosHttpAdapter(
        axios.create({
          baseURL: envs.APP_PROJECT_API_URL,
          timeout: Number(localStorage.getItem(LocalStorageKeys.AxiosTimeoutValue)) || 5000,
        }),
      ),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      new HttpCustomRetry({
        errorCodes: [ErrorCode.RateLimiting, ErrorCode.TooManyRequests],
      }),
    );
  }
}

injected(HttpClientProjectApi, DI_TOKENS.envs, DI_TOKENS.localStorageService);
